const pagesIndividualHomeEn = {
  application: {
    categories: {
      contractorCore: 'Contractor Core',
      gaOperationCore: 'GA Operation Core',
      itOperationCore: 'IT Operation Core',
      laborCore: 'Labor Core',
    },
    emptyState: {
      description:
        'Currently, there are no requests or notifications available. If new ones become available, they will be displayed in this section.',
      title: 'No requests or notifications available',
    },
    title: 'Request',
  },
  applicationOperationPackages: {
    cores: {
      contractorCore: 'Contractor Core',
      gaOperationCore: 'GA Operation Core',
      itOperationCore: 'IT Operation Core',
      laborCore: 'Labor Core',
    },
    title: 'Submit',
  },
  approvalTray: {
    empty: 'No approval tasks',
    emptyState: {
      allCompleted: 'All approvals completed',
      description:
        'Currently, there are no tasks that require approval. If a new approval task arises, it will be displayed here.',
    },
    status: {
      waitingApproval: 'Waiting for approval',
    },
    tableHeaders: {
      applicant: 'Applicant',
      approvalFlow: 'Approval Flow',
      approvalTask: 'Approval Task',
      deadline: 'Deadline',
    },
    title: 'Approval Tray',
  },
  chat: {
    agent: 'Agent',
    placeholder: 'Get your business operation done',
  },
  clocking: {
    clockIn: 'Clock in',
    clockOut: 'Clock out',
    editRequest: 'Edit request',
    leaveRequest: 'Leave request',
    missedPunch: 'Missed punch',
    title: 'Attendance Book',
  },
  greeting: {
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    morning: 'Good morning',
  },
  inquiry: {
    title: 'Inquiry & Reference',
  },
  lookup: {
    clockingCard: {
      empty: 'No attendance summary available yet.',
      title: 'Attendance Book',
      viewDetail: 'View details',
    },
    monthLabel: 'M{{month}}',
    paySlipCard: {
      empty: 'No pay slip available yet.',
      scheduledLabel: 'Scheduled',
      title: 'Pay slip',
      viewDetail: 'View details',
    },
    title: 'Inquiry & Reference',
  },
  myRequests: {
    empty: 'No requests',
    status: {
      approved: 'Approved',
      pending: 'Pending',
      rejected: 'Rejected',
    },
    tableHeaders: {
      progress: 'Progress',
      requestDate: 'Request Date',
      requestType: 'Request Type',
      status: 'Status',
    },
    title: 'My Requests',
  },
  myTasks: {
    empty: 'No tasks assigned',
    tableHeaders: {
      dueDate: 'Due date',
      progress: 'Progress',
      task: 'Task',
    },
    title: 'My Tasks',
  },
  name: '{{name}}',
  nav: {
    descriptive: {
      approvalTray: 'Approval Tray',
      attendance: 'Attendance',
      contract: 'Contract',
      devices: 'Devices',
      hr: 'HR',
      it: 'IT',
      labor: 'Labor',
      myRequests: 'My Requests',
      software: 'Software',
      tasks: 'Tasks',
    },
    lookup: 'Inquiry & Reference',
    myTasks: 'My Tasks',
    requests: 'Request',
  },
  nextTask: 'Next Task',
  operationPackages: {
    emptyState: {
      allCompleted: 'All completed',
      description:
        'Currently, there are no procedures that require attention. If a new procedure arises, it will be displayed on this page.',
    },
  },
  taskStatuses: {
    ongoing: 'Ongoing',
  },
  viewAll: 'View all',
  welcome: 'Welcome',
};

export default pagesIndividualHomeEn;
